import { FlexCenter, Switch } from '@elementary/common-ui/components';
import useEnvPermission from '@elementary/common-ui/hooks/useEnvPermission';
import { CircularProgress, Tooltip } from '@mui/material';
import useTestNotificationsSettings from 'testManagement/hooks/useTestNotificationsSettings';

const MuteTestToggleCell = ({ id, muted }: { id: string; muted: boolean }) => {
  const { isMuteTestsLoading, isUnMuteTestsLoading, unMuteTests, muteTests } =
    useTestNotificationsSettings();

  const hasPermission = useEnvPermission();

  const hasPermissions = hasPermission('EDIT_ALERT_RULES');
  return (
    <FlexCenter sx={{ gap: 1 }} onClick={(e) => e.stopPropagation()}>
      {isMuteTestsLoading || isUnMuteTestsLoading ? (
        <CircularProgress size={16} />
      ) : (
        <Tooltip
          title={
            !hasPermissions && "You don't have permissions to modify alerts"
          }
        >
          <div>
            <Switch
              disabled={!hasPermissions}
              checked={!muted}
              onChange={(_, checked) => {
                if (checked) unMuteTests([id]);
                else muteTests([id]);
              }}
            />
          </div>
        </Tooltip>
      )}
    </FlexCenter>
  );
};

export default MuteTestToggleCell;
